/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryGroupNews
 */
export interface LaundryGroupNews {
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupNews
     */
    readonly id: string;
    /**
     * 
     * @type {Date}
     * @memberof LaundryGroupNews
     */
    readonly date: Date;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupNews
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupNews
     */
    content: string;
}

/**
 * Check if a given object implements the LaundryGroupNews interface.
 */
export function instanceOfLaundryGroupNews(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function LaundryGroupNewsFromJSON(json: any): LaundryGroupNews {
    return LaundryGroupNewsFromJSONTyped(json, false);
}

export function LaundryGroupNewsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupNews {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function LaundryGroupNewsToJSON(value?: LaundryGroupNews | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': value.subject,
        'content': value.content,
    };
}

